/**
 * Logs API service.
 * Provides operations for retrieving log events for self-service debugging.
 *
 * API Endpoints:
 * - GET /logs/traces/:traceId - Get all log events for a specific trace
 *
 * @module services/logsService
 */

import { httpClient } from './httpClient';
import type { LogsTraceEventsResponse } from '@/types';

const ENDPOINT = '/logs';

/**
 * Logs Service
 * Encapsulates logs API operations for self-service debugging
 */
export const logsService = {
  /**
   * Get all log events for a specific trace ID
   * @param traceId - The trace ID to query
   * @returns Promise<LogsTraceEventsResponse> - All events for the trace
   */
  async getTraceEvents(traceId: string): Promise<LogsTraceEventsResponse> {
    console.log('[LogsService] Fetching trace events:', traceId);
    const encodedId = encodeURIComponent(traceId);
    try {
      const response = await httpClient.get<LogsTraceEventsResponse>(
        `${ENDPOINT}/traces/${encodedId}`
      );
      console.log('[LogsService] Fetched trace events for:', traceId);
      return response.data;
    } catch (error) {
      console.error('[LogsService] Failed to fetch trace events:', traceId, error);
      throw error;
    }
  },
};
